import { useCallback, useRef } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { exportShadowTeamPdf } from "../../../store/shadowTeam/shadowTeamService";

const downloadBlob = (response, fallbackFilename = "shadow-team.pdf") => {
  const blob = new Blob([response.data], {
    type: response?.headers?.["content-type"] || "application/pdf",
  });
  const fileUrl = window.URL.createObjectURL(blob);

  const contentDisposition = response?.headers?.["content-disposition"] || "";
  const filenameMatch = contentDisposition.match(
    /filename\*?=(?:UTF-8''|")?([^";]+)/i
  );
  const filename = filenameMatch?.[1]?.trim() || fallbackFilename;

  const link = document.createElement("a");
  link.href = fileUrl;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(fileUrl);
};

const useShadowTeamExport = ({ shadowTeamId, teamName }) => {
  const dispatch = useDispatch();
  const { i18n } = useTranslation();
  const isExportingRef = useRef(false);

  const exportToPdf = useCallback(async () => {
    if (isExportingRef.current || !shadowTeamId) return;

    isExportingRef.current = true;

    try {
      const response = await dispatch(
        exportShadowTeamPdf({
          shadowTeamId,
          locale: i18n?.language || "en",
        })
      ).unwrap();

      const safeName = String(teamName || "shadow-team")
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "");

      downloadBlob(response, `${safeName}.pdf`);
    } finally {
      isExportingRef.current = false;
    }
  }, [dispatch, shadowTeamId, teamName, i18n]);

  return { exportToPdf };
};

export default useShadowTeamExport;
